import { z } from 'zod';

export const detailsPricingPlanSchema = z
  .object({
    details: z.object({
      products: z.object({
        electricityFluxId: z.string().optional().nullable(),
        gasFluxId: z.string().optional().nullable(),
      }),
      referralCode: z.string().optional(),
    }),
  })
  .transform(({ details }) => ({
    electricity_promo_code: details.products.electricityFluxId
      ? details.products.electricityFluxId
      : undefined,
    gas_promo_code: details.products.gasFluxId
      ? details.products.gasFluxId
      : undefined,
    ...(details.referralCode ? { referral_code: details.referralCode } : {}),
    estimated_usage: 50,
    estimated_usage_units: 'dollars_per_month',
  }));

export type DetailsPricingPlanSchema = z.infer<typeof detailsPricingPlanSchema>;
